/**
 * Filter object by given function.
 *
 * @param {Object} obj
 * @param {function} filter - for example x => x.value > 1
 * @returns {Object|null}
 */
export default (obj, filter) => {
    if (!obj) {
        return null;
    }

    return Object.keys(obj)
        .filter(key => filter(obj[key]))
        .reduce((res, key) => Object.assign(res, { [key]: obj[key] }), {});
};
